
// src/web/components/user-block-panel.jsx

import React from 'react'
import connect from '../../connects/user-block-panel'
import {
  Card,
  CardText,
  CardActions,
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import theme from './themes/flat-card.css'
import successButtonTheme from './themes/success-button.css'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import FontIcon from 'react-toolbox/lib/font_icon'
import ConfirmDialog from './confirm-dialog.jsx'

class UserBlockPanel extends React.Component {
  state = {}

  render() {
    const {
      t,
      isFetching,
      favorites,
      current,
      groups,
      favoriteGroup,
      favoriteUser,
      setFavoriteUser,
      showUserSelectionDialog,
      blockUsers,
      updateBlockUser,
      onClose
    } = this.props

    return (
    <Card theme={theme}>
      <CardText>
        <normal><strong>{t('label:ブロックされたユーザ')}</strong></normal>
        <List selectable>
          {blockUsers && blockUsers.length > 0 && blockUsers.map((user)=> 
            <ListItem key={user.user_id}
                disabled={isFetching}
                caption={user.name}
                avatar={user.icon_image.thumb_url}
                rightActions={_.filter([
                  <IconButton key='button' icon='close'
                      disabled={isFetching}
                      onClick={()=> this.setState({ [user.user_id]: true })} />,
                  <ConfirmDialog key={'confirm'+user.user_id}
                    title={t('label:ブロックユーザの解除', { name: user.name })}
                    description={t('label:ブロックユーザの解除説明')}
                    open={this.state[user.user_id]}
                    onYes={()=> {
                      this.setState({ [user.user_id]: false })
                      updateBlockUser(user, false)
                      blockUsers && blockUsers.length == 1 && onClose()
                    }}
                    onNo={()=> { this.setState({ [user.user_id]: false }) }}
                    yesLabel={t('label:ブロック解除')}
                    noLabel={t('label:取り消し')} />
                ])}/>
          )}
          {blockUsers && blockUsers.length == 0 &&
            <ListItem caption={t('label:ブロックされたユーザはありません')} />
          }
        </List>
      </CardText>
    </Card>
    )
  }
}

export const RawUserBlockPanel = UserBlockPanel
export default connect(UserBlockPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-block-panel.jsx